export const CENTS_IN_A_DOLLAR = 100;
